import React, { useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';

const BtnCompatible = ({IdInput, texto, style}) => {
    // let textColor = props.color;
    // let backgroundColor = props.backgroundColor;
    // let style = props.style;
   
    return (
        <div id={`tooltip-compatible${IdInput}`} className="tooltip-compatible" style={style} >
            <SvgAssets icon="icon-compatible" fill={c.azulClaro} />
            <UncontrolledTooltip placement="top" target={`tooltip-compatible${IdInput}`} className="tooltip-compatible">
                <span className="light">Modelo:</span>
                <span>{texto == null ? "-" : texto}</span>
            </UncontrolledTooltip>
        </div>
    );
}

export default BtnCompatible;